import React, { type ReactNode } from "react";
import { styled, Box, Typography, type BoxProps, type TypographyProps } from "@mui/material";

import { type FormattedMessageElement, isFormattedMessageElement } from "../../../utils/react-intl";

interface ModalTitleProps extends Omit<TypographyProps, "title"> {
	title: string | FormattedMessageElement;
}

export const ModalTitle: React.FC<ModalTitleProps> = styled((props) => <Typography variant="h2" {...props} />)({
	overflow: "hidden",
	textOverflow: "ellipsis",
	whiteSpace: "nowrap",
});

const StyledModalTitleContainer: React.FC<BoxProps> = styled(Box)({
	gridArea: "title",
	overflow: "hidden",
});

interface ModalTitleContainerProps extends BoxProps {
	readonly children: ReactNode;
}

export const ModalTitleContainer: React.FC<ModalTitleContainerProps> = ({ children, ...props }) => {
	const isText = typeof children === "string" || isFormattedMessageElement(children);

	return (
		<StyledModalTitleContainer {...props}>
			{isText === true && <ModalTitle title={children}>{children}</ModalTitle>}
			{isText === false && children}
		</StyledModalTitleContainer>
	);
};
